import { useEffect, useRef, useState } from 'react'
import { api } from '../lib/api.js'
import { dispatchNoticeText, noticeMotion, watchDispatchNotices } from '../lib/dispatchNotices.js'
import './dispatch-notice.css'

export default function DispatchNotice({ agentId }) {
  const [result, setResult] = useState(null)
  const [motion, setMotion] = useState({ distance: 0, duration: 8 })
  const viewport = useRef(null)
  const content = useRef(null)
  const text = result?.available === false
    ? '派单提醒暂不可用'
    : dispatchNoticeText(result?.notices, result?.total)

  useEffect(() => watchDispatchNotices({
    load: api.listDispatchNotices, publish: setResult, agentId,
  }), [agentId])

  useEffect(() => {
    if (!text || !viewport.current || !content.current) return
    const measure = () => setMotion(noticeMotion(
      content.current.scrollWidth, viewport.current.clientWidth,
    ))
    const observer = new ResizeObserver(measure)
    observer.observe(viewport.current)
    observer.observe(content.current)
    measure()
    return () => observer.disconnect()
  }, [text])

  if (!text) return null
  const moving = motion.distance > 1
  return (
    <div className={`dispatch-notice${result?.available === false ? ' unavailable' : ''}`}>
      <div ref={viewport} className={`dispatch-notice-viewport${moving ? ' is-scrolling' : ''}`}
        tabIndex={moving ? 0 : undefined} title={text} aria-label={text}
        style={{ '--notice-distance': `${-motion.distance}px`, '--notice-duration': `${motion.duration}s` }}>
        <span ref={content} key={text} className="dispatch-notice-content">{text}</span>
      </div>
    </div>
  )
}
